import { useState } from 'react';
import { TopicLogic } from '../logic';

/**
 * A topic's location, with its time zone following it: a location naming a
 * place `TopicLogic.timezoneForPlace` knows sets the zone, until the author
 * picks a zone themselves. `releaseZone` lets go of a picked zone, so the zone
 * follows the location again.
 */
export function useZoneFollowingLocation(
  location: string,
  setLocation: (value: string) => void,
  setTimezone: (value: string) => void
) {
  const [zonePicked, setZonePicked] = useState(false);

  const followPlace = (place: string) => {
    const zone = TopicLogic.timezoneForPlace(place);
    if (zone) setTimezone(zone);
  };

  return {
    changeLocation: (value: string) => {
      setLocation(value);
      if (!zonePicked) followPlace(value);
    },
    pickZone: (value: string) => {
      setZonePicked(true);
      setTimezone(value);
    },
    releaseZone: () => {
      setZonePicked(false);
      followPlace(location);
    },
  };
}
